const slugRegExp = /^[\dA-Za-z](|[-\dA-Za-z]{0,61}[\dA-Za-z])$/;

export const isValidSlug = (value) => slugRegExp.test(value);

export const isValidURL = (value) => {
  let url;
  try {
    url = new URL(value);
  } catch (err) {
    return false;
  }

  if (url.protocol !== 'http:' && url.protocol !== 'https:') {
    return false;
  }

  if (url.origin.split('.').length === 1) {
    return false;
  }

  return true;
}

